export const FILTER_LIST_ITEM_PADDING = 0.5;
